<template>
    <div class="survey-container">
        <div class="survey"
            v-for="(item, index) in list"
            :key="index">
            <div class="survey-inner">
                <span class="survey-title">{{ item.surveyName }}</span>
                <div class="survey-option">
                    <span>作答时间：</span>
                    <span>{{ item.answerDate }}</span>
                </div>
                <div class="survey-option">
                    <span>作答报酬：</span>
                    <span>{{ item.answerAward }} 元</span>
                </div>
                <div class="survey-option">
                    <span>红包报酬：</span>
                    <span>{{ item.redReward }} 元</span>
                </div>
                <div class="survey-option">
                    <span>审核状态：</span>
                    <span>{{ getStatus(item.auditStatus) }}</span>
                </div>
            </div>
        </div>
    </div>
</template>

<style scoped>
.survey-container{
    display: flex;
    flex-direction: column;
    align-items: center;
}
.survey{
    display: flex;
    flex-direction: column;
    width: 8.93rem;
    background: #E7F2FF;
    border-radius: 9px;
    padding: .27rem .37rem;
    margin-bottom: .37rem;
    position: relative;
}
.survey-inner{
    display: flex;
    flex-direction: column;
}
.survey-title{
    display: -webkit-box;
    font-size: 0.48rem;
    line-height: 0.69rem;
    font-weight: bold;
    overflow: hidden;
    text-overflow: ellipsis;
    -webkit-line-clamp: 2;  
    -webkit-box-orient: vertical;
    margin-bottom: .37rem;
}
.survey-option{
    display: flex;
    flex-direction: row;
    align-items: center;
    font-size: 0.37rem;
    color: #999999;
    margin-bottom: .21rem;
}
</style>

<script>
export default {
    props: {
        list: Array
    },
    methods: {
        getStatus(status) {
            switch (status) {
                case 1:
                    return "报酬挂起"
                case 3:
                    return "报酬到帐"
                default:
                    return "——"
            }
        }
    }
}
</script>


// WEBPACK FOOTER //
// src/components/data-market/m/record-list.vue